
import { defineComponent, ref } from 'vue';
import API from 'boot/api';

export default defineComponent({
  name: 'AddChannelCard',
  emits: [
    'channel',
  ],
  setup(props, context) {
    const channelName = ref('');
    const error = ref('');
    const loading = ref(false);

    const onSubmit = async () => {
      try {
        loading.value = true;

        const channel = await API.addChannel(channelName.value);
        context.emit('channel', channel);
      } catch (err) {
        if (err instanceof Error) {
          error.value = err.message;
        } else {
          error.value = String(err);
        }
      } finally {
        loading.value = false;
      }
    };

    return {
      channelName,
      error,
      loading,
      onSubmit,
    };
  },
});
